// Minnesotaänger Mini App — conversation-list entry point.
// The mobile Chats view owns its visual hierarchy instead of inheriting the
// Telegram Web left-column row styles. The data and navigation actions remain
// the shared Mini App contracts.

import { memo, useEffect } from '@teact';

import type { ElementRef } from '@teact';

import { getActions, withGlobal } from '../../global';

import type { ApiMiniAppConversation } from '../../api/miniapp/types';

import {
  selectActiveChatId,
  selectConversations,
  selectConversationsError,
  selectIsLoadingConversations,
} from '../../global/selectors/miniapp';

import ChatsHome from './ChatsHome';

type OwnProps = {
  ref: ElementRef<HTMLDivElement>;
  // Kept for Main.tsx compatibility; v1 has no folders sidebar.
  isFoldersSidebarShown: boolean;
};

type StateProps = {
  conversations: ApiMiniAppConversation[];
  isLoading: boolean;
  conversationsError: string | null;
  activeChatId?: string;
};

function LeftColumn(
  { ref, conversations, isLoading, conversationsError, activeChatId }: OwnProps & StateProps,
) {
  const { openChat, loadConversations } = getActions();

  useEffect(() => {
    loadConversations();
    // Load once on mount; refresh is manual in v1.
  }, [loadConversations]);

  return (
    <div id="LeftColumn" ref={ref}>
      <ChatsHome
        conversations={conversations}
        conversationsError={conversationsError}
        isLoading={isLoading}
        activeChatId={activeChatId}
        onOpenChat={(chatId) => openChat({ chatId })}
        onRetry={loadConversations}
      />
    </div>
  );
}

export default memo(withGlobal<OwnProps>(
  (global): StateProps => ({
    conversations: selectConversations(global),
    isLoading: selectIsLoadingConversations(global),
    conversationsError: selectConversationsError(global),
    activeChatId: selectActiveChatId(global),
  }),
)(LeftColumn));
